import React from "react";
import cx from "classnames";
import Button from "components/Button";
import { Subscription } from "store/subscriptions/types";

interface Props extends Subscription {
  type: string;
  daysLeft?: number;
  price: number;
  purchaseable?: boolean;
  selected?: boolean;
  select: (string) => void;
  stripeId: string;
  period: string;
  unselectable?: boolean;
  hidePrice?: boolean;
  currency: string;
  trial?: boolean;
  abort?: boolean;
}

const SubscriptionCard = (props: Props) => {
  return (
    <div className={cx("subscription-card", { hoverable: props.purchaseable })}>
      <h4 className="title">{props.sale || ""}</h4>
      {!props.hidePrice && (
        <div className="info">
          <p className="price">
            {props.daysLeft
              ? `${props.daysLeft}`
              : `${props.currency}${props.price} `}
          </p>
          <p className="duration">per {props.period}</p>
        </div>
      )}
      <button
        onClick={() => !props.unselectable && props.select(props._id)}
        className="subscribe-button"
      >
        {props.abort
          ? props.trialTitle
            ? "TRY FOR FREE"
            : "GET STARTED"
          : "GET STARTED"}
      </button>
    </div>
  );
};

export default SubscriptionCard;
